import React, { useState, useEffect } from 'react';
import { useRef } from 'react';
import axios from 'axios';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, updateData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import CopyrightIcon from '@mui/icons-material/Copyright';
import CircularProgress from '@mui/material/CircularProgress';
import { Box } from '@mui/material';
import CreateIcon from '@mui/icons-material/Create';
import AddIcon from '@mui/icons-material/Add';
import InfoIcon from '@mui/icons-material/Info';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import { Tooltip } from '@mui/material';
import {
    Checkbox, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, TableSortLabel, TablePagination, TableFooter
} from '@mui/material';
import Modal from '@mui/material/Modal';
import { Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useLocation, Link } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

function DetailedInvoice() {

    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const [loading, setLoading] = useState(false);
    const { isAuthenticated, companyId, branchId, permissions, token, username, logout } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();
        //fetchCustomerData();
    }, [isAuthenticated, companyId, token, branchId, logout]);

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    //FOR CHILD 
    const [ChildOptions, setchildOptions] = useState([]);
    const [selectedChildOption, setSelectedChildOption] = useState(null);

    const handleChildInputChange = (newValue) => newValue;

    // Handle customer selection
    const handleChildSelect = (selectedChildOption) => {
        setSelectedChildOption(selectedChildOption);

    };

    const fetchTableData = async () => {
        const itemid = 0;
        setDataItem([])
        setLoading(true);
        try {
            const response = await fetchData('ReportApi', `/DetailedInvoiceList/${fromDate}/${toDate}/${companyId}`, token);
            if (response.responseCode === '1111') {
                setDataItem(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Detailed Invoice List:', error);
        } finally {
            setLoading(false); // ✅ Hide loading screen always
        }

    };

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setFromDate(selectedDate);
    };

    // Similar function for toDate
    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setToDate(selectedDate);
    };

    const hasReadReportPermission = permissions.includes('Read Reports');

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataBill = dataBill.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    const handleExportExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Invoice Details');

        worksheet.views = [{ state: 'frozen', ySplit: 2 }];

        const now = new Date();
        const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;
        const thinBorder = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
        };

        // 🔹 REPORT HEADER
        worksheet.mergeCells('A1:S1');
        const headerCell = worksheet.getCell('A1');
        headerCell.value = `Invoice Details Data From: ${formatDate(fromDate)} To: ${formatDate(toDate)}  | Generated On: ${formattedDateTime} By: ${username}`;
        headerCell.font = { bold: true, size: 10 };
        headerCell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };

        worksheet.addRow([]);

        // 🔹 COLUMN HEADERS
        const headerTitles = [
            'Invoice Date',
            'Invoice Number',
            'Customer',
            'Consignee',
            'BL Number',
            'Invoice Amount',
            'Advance Amount',
            'Balance Amount',
            'Payment Received Date',
            'Receieved Amount',
            'Receipt Number',
        ];

        const headerRow = worksheet.addRow(headerTitles);
        headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: '000000' } };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9EAD3' }, // Light green
            };
            cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
            cell.border = thinBorder;
        });

        // 🔹 DATA ROWS
        filteredDataItem.forEach((rowData) => {
            const dataRow = [
                formatDate(rowData.InvoiceDate),
                rowData.InvoiceNumber,
                rowData.CustomerName,
                rowData.ConsigneeName,
                rowData.BLNumber,
                rowData.InvoiceAmount,
                rowData.AdvanceAmount,
                rowData.BalanceAmount,
                rowData.PaymentReceivedDate,
                rowData.ReceievedAmount,
                rowData.ReceiptNumber,
            ];

            const row = worksheet.addRow(dataRow);

            row.eachCell((cell, colNumber) => {
                cell.border = thinBorder;
                if ([6, 7, 8, 10].includes(colNumber)) {
                    cell.alignment = { horizontal: 'right', vertical: 'middle' };
                    cell.numFmt = '#,##0.00';
                } else {
                    cell.alignment = { horizontal: 'left', vertical: 'middle' };
                }
            });

            // ✅ Highlight rows containing "Total"
            if (
                String(rowData.MasterName)?.toLowerCase().includes('total') ||
                String(rowData.BillNumber)?.toLowerCase().includes('total')
            ) {
                row.eachCell((cell) => {
                    cell.font = { bold: true };
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFF4CCCC' }, // Light pink
                    };
                });
            }
        });

        // 🔹 TOTAL ROW CALCULATION
        const totalInvoiceAmount = filteredDataItem.reduce((sum, r) => sum + (parseFloat(r.InvoiceAmount) || 0), 0);
        const totalAdvanceAmount = filteredDataItem.reduce((sum, r) => sum + (parseFloat(r.AdvanceAmount) || 0), 0);
        const totalBalanceAmount = filteredDataItem.reduce((sum, r) => sum + (parseFloat(r.BalanceAmount) || 0), 0);
        const totalReceivedAmount = filteredDataItem.reduce((sum, r) => sum + (parseFloat(r.ReceievedAmount) || 0), 0);

        worksheet.addRow([]); // Empty line before total

        const totalRow = worksheet.addRow([
            '', '', '', '', 'TOTAL',
            totalInvoiceAmount,
            totalAdvanceAmount,
            totalBalanceAmount,
            '', // Payment Received Date
            totalReceivedAmount,
            '', // Receipt Number
        ]);

        totalRow.eachCell((cell, colNumber) => {
            cell.font = { bold: true };
            cell.border = thinBorder;
            cell.alignment = { horizontal: 'right', vertical: 'middle' };

            if ([6, 7, 8, 10].includes(colNumber)) {
                cell.numFmt = '#,##0.00';
            }

            // Make total label stand out
            if (colNumber === 5) {
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
                cell.font = { bold: true, color: { argb: '000000' } };
            }
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFF4CCCC' }, // Light pink for total row
            };
        });

        // 🔹 ADJUST COLUMN WIDTHS
        worksheet.columns = [
            { width: 15 }, { width: 12 }, { width: 25 }, { width: 15 },
            { width: 15 }, { width: 15 }, { width: 15 }, { width: 15 },
            { width: 18 }, { width: 15 }, { width: 15 },
        ];

        // 🔹 SAVE FILE
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(
            new Blob([buffer]),
            `Invoice_Details_From_${formatDate(fromDate).replace(/\//g, '-')}_To_${formatDate(toDate).replace(/\//g, '-')}.xlsx`
        );
    };



    const [page, setPage] = useState(0); // Current page
    const [rowsPerPage, setRowsPerPage] = useState(15); // Rows per page

    // Define initial column order
    const [columnOrder, setColumnOrder] = useState([
        'Invoice Date',
        'Invoice Number',
        'Customer',
        'Consignee',
        'BL Number',
        'Invoice Amount',
        'Advance Amount',
        'Balance Amount',
        'Payment Received Date',
        'Receieved Amount',
        'Receipt Number',
    ]);

    // Handle page change
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    // Handle rows per page change
    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset to the first page
    };

    // Function to handle drag start
    const handleDragStart = (e, index) => {
        e.dataTransfer.setData('columnIndex', index);
    };

    // Function to handle drag over
    const handleDragOver = (e) => {
        e.preventDefault(); // Allow drop
    };

    // Function to handle drop
    const handleDrop = (e, index) => {
        const draggedIndex = e.dataTransfer.getData('columnIndex');
        if (draggedIndex !== index) {
            const newOrder = [...columnOrder];
            // Swap columns
            [newOrder[draggedIndex], newOrder[index]] = [newOrder[index], newOrder[draggedIndex]];
            setColumnOrder(newOrder);
        }
    };

    const grandTotal = filteredDataItem
        .filter((rowData) => rowData.MasterName === "Total")
        .reduce(
            (totals, rowData) => ({
                InvoiceAmount: parseFloat((totals.InvoiceAmount + (parseFloat(rowData.InvoiceAmount) || 0)).toFixed(2)),
                AdvanceAmount: parseFloat((totals.AdvanceAmount + (parseFloat(rowData.AdvanceAmount) || 0)).toFixed(2)),
                BalanceAmount: parseFloat((totals.BalanceAmount + (parseFloat(rowData.BalanceAmount) || 0)).toFixed(2)),
                ReceivedAmount: parseFloat((totals.ReceivedAmount + (parseFloat(rowData.ReceivedAmount) || 0)).toFixed(2)),
            }),
            {
                InvoiceAmount: 0,
                AdvanceAmount: 0,
                BalanceAmount: 0,
                ReceivedAmount: 0,
            }
        );

    console.log(grandTotal);

    // Process and paginate the data
    const processedData = filteredDataItem.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );

    return (
        <div
            className="w-full mx-auto"
            style={{
                width: "100%",
                marginTop: "0",
                background: "#fff",
                border: "1px solid #dcdcdc",
                borderRadius: "6px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            }}
        >
            {loading && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999
                }}>
                    <div className="loader"></div>
                    <span style={{ color: 'white', marginTop: '10px', fontSize: '14px' }}>
                        Loading...
                    </span>
                </div>
            )}
            {/* ===== Report Header ===== */}
            <div
                style={{
                    background: "whitesmoke",
                    color: "black",
                    padding: "5px 10px",
                    borderTopLeftRadius: "6px",
                    borderTopRightRadius: "6px",
                    fontSize: "12px",
                    fontWeight: "bold",
                    letterSpacing: "0.5px",
                    marginTop: '-30px',
                    height: '30px'
                }}
            >
                INVOICE DETAILS REPORT
            </div>

            {/* ===== Filter Section ===== */}
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "10px 15px",
                    borderBottom: "1px solid #eee",
                    background: "#fafafa",
                }}
            >
                {/* Search */}
                <input
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={handleSearch}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    style={{
                        width: isFocused ? "260px" : "200px",
                        height: "30px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        padding: "0 10px",
                        transition: "width 0.3s",
                        outline: "none",
                        fontSize: "13px",
                        marginLeft: '-15px'
                    }}
                />

                {/* Dates + Buttons */}
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    {/* From Date */}
                    <div>
                        <label style={{ fontSize: "11px", color: "#555" }}>From</label>
                        <input
                            type="date"
                            value={fromDate}
                            onChange={handleFromDateChange}
                            style={{
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                padding: "2px 6px",
                                fontSize: "12px",
                                height: "28px",
                                marginLeft: "5px",
                            }}
                        />
                    </div>

                    {/* To Date */}
                    <div>
                        <label style={{ fontSize: "11px", color: "#555" }}>To</label>
                        <input
                            type="date"
                            value={toDate}
                            onChange={handleToDateChange}
                            style={{
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                padding: "2px 6px",
                                fontSize: "12px",
                                height: "28px",
                                marginLeft: "5px",
                            }}
                        />
                    </div>

                    {/* Refresh */}
                    <Button
                        onClick={fetchTableData}
                        style={{
                            background: "#2f4050",
                            color: "white",
                            borderRadius: "4px",
                            padding: "5px 12px",
                            fontSize: "13px",
                            fontWeight: "bold",
                            height: "28px",
                        }}
                    >
                        Refresh
                    </Button>

                    {/* Excel */}
                    <Button
                        onClick={handleExportExcel}
                        style={{
                            background: "#00695c",
                            color: "white",
                            borderRadius: "4px",
                            padding: "5px 12px",
                            fontSize: "13px",
                            fontWeight: "bold",
                            height: "28px",
                        }}
                    >
                        Excel
                    </Button>
                </div>
            </div>

            {/* ===== Table Section ===== */}
            <div className='w-full mb-5 flex' style={{ maxHeight: '500px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#102E50' }}>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '10px', color: 'whitesmoke', padding: '3px', fontWeight: 'bold', textTransform: 'uppercase' }}>Invoice Date</TableCell>
                                <TableCell sx={{ backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '10px', color: 'whitesmoke', padding: '3px', fontWeight: 'bold', textTransform: 'uppercase' }}>Invoice No</TableCell>
                                <TableCell sx={{ backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '10px', color: 'whitesmoke', padding: '3px', fontWeight: 'bold', textTransform: 'uppercase' }}>Customer</TableCell>
                                <TableCell sx={{ backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '10px', color: 'whitesmoke', padding: '3px', fontWeight: 'bold', textTransform: 'uppercase' }}>Consignee</TableCell>
                                <TableCell sx={{ backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '10px', color: 'whitesmoke', padding: '3px', fontWeight: 'bold', textTransform: 'uppercase' }}>Bl No</TableCell>
                                <TableCell sx={{ backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '10px', color: 'whitesmoke', textAlign: 'right', padding: '3px', fontWeight: 'bold', textTransform: 'uppercase' }}>Inv.Amount</TableCell>
                                <TableCell sx={{ backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '10px', color: 'whitesmoke', textAlign: 'right', padding: '3px', fontWeight: 'bold', textTransform: 'uppercase' }}>Adavance </TableCell>
                                <TableCell sx={{ backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '10px', color: 'whitesmoke', textAlign: 'right', padding: '3px', fontWeight: 'bold', textTransform: 'uppercase' }}>Balance</TableCell>
                                <TableCell sx={{ backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '10px', color: 'whitesmoke', textAlign: 'right', padding: '3px', fontWeight: 'bold', textTransform: 'uppercase' }}>Pay.Rec.Date</TableCell>
                                <TableCell sx={{ backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '10px', color: 'whitesmoke', textAlign: 'right', padding: '3px', fontWeight: 'bold', textTransform: 'uppercase' }}>Receieved </TableCell>
                                <TableCell sx={{ backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '10px', color: 'whitesmoke', textAlign: 'right', padding: '3px', fontWeight: 'bold', textTransform: 'uppercase' }}>Receipt No</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredDataItem.map((data, index) => (
                                <TableRow key={data.id}>
                                    <TableCell sx={{ padding: '3px', fontSize: '11.5px' }}>{formatDate(data.InvoiceDate)}</TableCell>
                                    <TableCell sx={{ padding: '3px', fontSize: '11px', fontWeight: 'bold' }}>
                                        <a
                                            href={`/InvoiceDetails/${data.Id}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ color: '#aa5107ff' }}
                                        >
                                            {data.InvoiceNumber}
                                        </a>
                                    </TableCell>
                                    <TableCell sx={{ padding: '3px', fontSize: '11px' }}>{data.CustomerName}</TableCell>
                                    <TableCell sx={{ padding: '3px', fontSize: '11px' }}>{data.ConsigneeName}</TableCell>
                                    <TableCell sx={{ padding: '3px', fontSize: '11px' }}>{data.BLNumber}</TableCell>
                                    <TableCell sx={{ padding: '3px', textAlign: 'right', fontSize: '11.5px' }}>
                                        {data.InvoiceAmount?.toFixed(3) ?? "--"}
                                    </TableCell>
                                    <TableCell sx={{ padding: '3px', textAlign: 'right', fontSize: '11.5px' }}>
                                        {data.AdvanceAmount?.toFixed(3) ?? "--"}
                                    </TableCell>
                                    <TableCell sx={{ padding: '3px', textAlign: 'right', fontSize: '11.5px' }}>
                                        {data.BalanceAmount?.toFixed(3) ?? "--"}
                                    </TableCell>
                                    <TableCell sx={{ padding: '3px', textAlign: 'right', fontSize: '11.5px' }}>{data.PaymentReceivedDate}</TableCell>
                                    <TableCell sx={{ padding: '3px', textAlign: 'right', fontSize: '11.5px' }}>
                                        {data.ReceivedAmount?.toFixed(3) ?? "--"}
                                    </TableCell>
                                    <TableCell sx={{ padding: '3px', textAlign: 'right', fontSize: '11.5px' }}>{data.ReceiptNumber}</TableCell>
                                </TableRow>
                            ))}

                            {/* Totals Row */}
                            {filteredDataItem.length > 0 && (
                                <TableRow sx={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>
                                    <TableCell colSpan={5} sx={{ padding: '3px', fontWeight: 'bold' }}>
                                        Total
                                    </TableCell>
                                    <TableCell sx={{ padding: '3px', textAlign: 'right', fontWeight: 'bold' }}>
                                        {filteredDataItem.reduce((sum, item) => sum + (item.InvoiceAmount || 0), 0).toFixed(3)}
                                    </TableCell>
                                    <TableCell sx={{ padding: '3px', textAlign: 'right', fontWeight: 'bold' }}>
                                        {filteredDataItem.reduce((sum, item) => sum + (item.AdvanceAmount || 0), 0).toFixed(3)}
                                    </TableCell>
                                    <TableCell sx={{ padding: '3px', textAlign: 'right', fontWeight: 'bold' }}>
                                        {filteredDataItem.reduce((sum, item) => sum + (item.BalanceAmount || 0), 0).toFixed(3)}
                                    </TableCell>
                                    <TableCell sx={{ padding: '3px', fontWeight: 'bold' }}></TableCell>
                                    <TableCell sx={{ padding: '3px', textAlign: 'right', fontWeight: 'bold' }}>
                                        {/* Example: show total due days or leave blank */}
                                        {filteredDataItem.reduce((sum, item) => sum + (item.ReceivedAmount || 0), 0).toFixed(3)}
                                    </TableCell>
                                    <TableCell sx={{ padding: '3px', fontWeight: 'bold' }}></TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div>
    );

    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }

    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }

    function stableSort(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
    }

}
export default DetailedInvoice;